// errors-handler.ts
import { ErrorHandler, Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material'
@Injectable()
export class ErrorsHandler implements ErrorHandler {
  constructor(
    private snackbar: MatSnackBar
  ) { }
  handleError(error: Error) {

    console.error('Error catch : ', error)
  }
}